import styled from 'styled-components';
import { h6Styles, pStyles } from 'utils/resuable-css';
import { deviceBreakpoints, variables } from 'variables';

export const CreateTicketStep4SC = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: ${variables.pageContentPadding}px;
  padding-top: 70px;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const StepDescription = styled.div`
  margin-top: 40px;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    width: 90%;
  }
`;

export const SubmitReply = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
  width: 100%;
  display: flex;
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Reply = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
  width: 100%;
  margin-right: 10px;
  max-width: 800px;
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const TextArea = styled.div`
  margin: 3em 0;
  display: flex;
  align-item: center;
  flex-wrap: wrap;
  .text {
    width: 440px;
    margin-right: 10px;
    p,
    h6 {
      margin: 0;
    }
  }
  textarea {
    width: 350px;
    font-size: ${(props) => props.theme.default?.h6};
    ${(props) => h6Styles(props.theme.resolutions)};
    border: 2px solid lightgray;
    border-bottom: 2px solid ${(props) => props.theme.primaryDarkColor};
    border-radius: 5px;
    resize: none;
    padding: 10px;
  }
`;

export const Dept = styled.div`
  display: flex;
  margin-top: 1em;
  cursor: pointer;
  margin-left: ${(props) => (props.subdept ? '2em' : '0')};
  p {
    font-size: 17px;
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
  }
`;

export const SearchUsername = styled.div`
  margin: 1em 0;
  width: 50%;
`;

export const Search = styled.div`
  margin-right: 10px;
  display: flex;
  flex-direction: column;
`;

export const SearchResult = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
  h5 {
    margin: 0;
  }
  .email {
    display: flex;
    color: #4183c4;
    margin: 10px 5px;
    cursor: pointer;
    i {
      font-size: 8px;
      margin-top: 3px;
      margin-right: 8px;
    }
    h6 {
      margin: 0;
      font-weight: bold;
      text-decoration: underline;
    }
  }
`;

export const SearchContainer = styled.div`
  background: white;
  position: absolute;
  border-radius: 5px;
  z-index: 1000;
  margin-top: 5.7em;
  box-shadow: lightgray 0px 0px 24px 5px;
  .link {
    display: flex;
    padding: 1em;
    border-bottom: 1px solid ${(props) => props.theme.dividerColor};
  }
  h6 {
    margin: 0;
    color: black;
    cursor: pointer;
  }
  i {
    color: black;
    font-size: 10px;
    margin-top: 2px;
    margin-right: 12px;
  }
`;
